<template>
  <div>
    <div v-if="!loading">
      <div class="detail_outer_wrapper">
        <div class="detail_wrapper">
          <router-link v-if="!isRedirect" class="back_to_list" :to="{path: from?decodeURIComponent(from):'/lives'}">
            <Icon type="ios-arrow-back" />{{from?'返回':'返回直播列表'}}
          </router-link>
          <div class="detail_container">
            <div id="Detail">
              <div v-if="permission" class="media-video background-image-cover">
                <MediaPlayer
                  :onlineMemberType="course.onlineMemberType"
                  :onlineMemberNum="onlineMemberNum"
                  :coursePv="coursePv"
                  :courseId="course.pkid"
                  :startTime="course.startTime"
                  :channel="course.channel"
                  :state="course.state"
                  :cover="course.cover"
                  :watchTime="learnTime"
                ></MediaPlayer>
              </div>
              <div class="detail_message">
                <div class="detail_message_content">
                  <p class="detail_title">
                    <span>{{course.title}}</span>
                  </p>
                  <div class="detail_other">
                    <div class="item date">{{course.expectStartTime | Date('{y}-{m}-{d}')}}</div>
                    <div class="item time">{{course.expectStartTime | Date('{h}:{i}')}} - {{(course.expectStartTime + course.expectTime) | Date('{h}:{i}')}}</div>
                    <div class="splice_line"></div>
                    <div v-if="!isRedirect" class="item share" @click="handleShowPoster()">
                      <Icon type="md-share" />
                      <span>生成专属海报</span>
                    </div>
                    <Poptip placement="bottom" width="400" :visible.sync="courseWareVisible" @on-popper-hide="courseWareVisible=false">
                      <div class="item attach" @click="courseWareVisible=true">
                        <Icon type="md-attach" />
                        <span>课件</span>
                      </div>
                      <template slot="content">
                        <Courseware v-if="courseWareVisible" :course="course"></Courseware>
                      </template>
                    </Poptip>
                    <!-- <Poptip placement="bottom" width="300">
                      <div class="item contact">
                        <Icon type="md-person" />
                        <span>课程联系人</span>
                      </div>
                      <template slot="content">
                        <div class="contact_hit" v-if="!course.contactUrl">
                          <span class="hint-info">暂无课程联系人</span>
                        </div>
                        <img class="contact_img" v-else :src="course.contactUrl"/>
                      </template>
                    </Poptip> -->
                  </div>
                </div>
                <div v-if="course.state === COURSE_STATE.FORECAST && course.signUpFlag !== undefined">
                  <VuiButton v-if="course.signUpFlag" class="cancel_signup" size="large" @click.native="setCourseSingup()">已报名</VuiButton>
                  <VuiButton v-else type="warning" size="large" @click.native="setCourseSingup()">报名</VuiButton>
                </div>
              </div>
              <i-rate :showStar.sync="showStar" @submitRate="submitRate" @closeRate="closeRate" />
              <RealLearnTime :showLearnTime.sync="showLearnTime" :learnTime="learnTime"  @closeLearnTimeModal="closeLearnTimeModal" />
              <CoursePoster :courseId="course.pkid" :state="course.state"/>
            </div>
            <main v-if="permission && course.pkid !== '806fbfb8844711eabd7db8599f49eeb4'">
              <CourseSideBar :course="course" :accounts="accounts" @changeCourseProps="changeCourseProps"></CourseSideBar>
            </main>
            <main v-else>
              <div>
                <div style="text-align: center; margin-top:15px">扫码互动&领取课程资料</div>
                <div style="text-align: center;"><img class="kefu" src="/img/fashuikefu.png" alt="法税小橙子"></div>
              </div>
            </main>
          </div>
        </div>
      </div>
      <div class="detail_description">
        <Tabs :value="tabValue" ref="tabs">
          <TabPane label="课程简介" name="description">
            <div>{{course.info}}</div>
          </TabPane>
        </Tabs>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import MediaPlayer from '@/components/business/MediaPlayer'
  import CourseSideBar from './detail/CourseSideBar'
  import CoursePoster from '@/components/business/CoursePoster'
  import IRate from '@/components/business/IRate'
  import RealLearnTime from '@/components/business/RealLearnTime'
  import chatBus from '@/bus/chat'
  import {CCC, COURSE_STATE, FISCAL_TAX, POPUP_TEXT} from '@/constant/constants'
  import sensorHelp from '@/vendor/sensors/help'
  import {LIVE_DETAIL_VISIT} from '@/constant/sensorEvent'
  import Courseware from '@/views/components/Courseware'
  import router from '@/router'

  let nimInstance

export default {
  name: 'LiveDetail',
  components: {
    CourseSideBar,
    CoursePoster,
    MediaPlayer,
    IRate,
    Courseware,
    RealLearnTime
  },
  data () {
    return {
      from:'',
      course: {
        pkid: this.$route.params.courseId,
        title: '',
        cover: '',
        channel: '',
        startTime: -1,
        expectStartTime: -1,
        createUser: '',
        signUpFlag: false,
        info: '',
        state: -1,
        chatGroup: '',
        dateString: '',
        needShowAllBtn: false,
        lecturerIds: [], // 老师数组
        assistantIds: [], // 助教数组
        onlineMemberType: 0, // 在线成员显示类型
      },
      learnTime: 0, // 真实的观看时长
      showStar: false,
      showLearnTime: false,
      accounts: [],
      permission: false,
      loading: false,
      tabValue: 'description',
      isRedirect: sessionStorage.getItem('redirectType') === FISCAL_TAX || sessionStorage.getItem('redirectType') === CCC,
      COURSE_STATE,
      courseWareVisible: false,
    }
  },
  created () {
    this.init()
    this.checkUserNeedModifyInfo()
  },
  beforeDestroy () {
    if (nimInstance) {
      nimInstance.disconnect()
      nimInstance = null
    }
  },
  computed: {
    ...mapState('app', ['isLogin']),
    ...mapState('chat', [
      'accid',
      'token',
      'onlineMemberNum',
    ]),
    ...mapState('course', ['showPoster','coursePv']),
  },
  watch: {
    '$route' (to, from) {
      if (to.path !== from.path) {
        this.course.pkid = this.$route.params.courseId
        this.init()
      }
    },
  },
  methods: {
    ...mapActions({
      findCourseStatisticVo: 'live/findCourseStatisticVo',
    }),
    checkUserNeedModifyInfo() {
      this.$store
              .dispatch('user/checkUserNeedModifyInfo')
              .then(res => {
                if (res) {
                  router.app.$Message.info('需要先完善个人信息再收看课程哦~')
                  this.$router.push({name: 'ProfileSettings'})
                }
              });
    },
    initStatisticVo() { // 获取真实的数据
      let id= this.course.pkid
      return this.findCourseStatisticVo({id}).then((res) => {
        this.learnTime = this.MillisecondToDate(res.cumulativeTime)
      })
    },
    MillisecondToDate(msd) {
      let time = parseFloat(msd) / 1000;   //先将毫秒转化成秒
      if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + "分钟"
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
                  parseInt(time / 3600.0)) * 60) + "分钟";
        }
      }
      return time;
    },
    // 发送评分
    submitRate ({ rate, evaluate }) {
      this.$store
        .dispatch('course/setCourseCommend', {
          content: evaluate,
          evaluate: rate,
          targetId: this.course.pkid,
          targetType: 1,
        })
        .then(data => {
          this.$store.commit('course/setCoinChange', { type: POPUP_TEXT.COMMENT_COURSE.value, deltaCoin: data.deltaCoin, deltaValue: data.deltaValue })
          this.$store.commit('course/setLevelChange', { level: data.level, levelName: data.levelName, icon: data.icon, starLevel: data.starLevel })
        })
      this.$store.commit('course/setShowPoster', true)
    },
    closeRate () {
      this.showStar = false
      this.$store.commit('course/setShowPoster', true)
    },
    closeLearnTimeModal () {
      this.showLearnTime = false
    },
    // 获取课程详情
    getCourseDetail () {
      return this.$store
        .dispatch('course/getCourseDetail', { courseId: this.course.pkid, from: this.$route.query.from })
        .then(course => {
          Object.assign(this.course, course)
          // #region 初始化 this.accounts（老师 + 助教 +创建者）
          if (!Array.isArray(this.course.lecturerIds)) {
            this.course.lecturerIds = []
          }
          if (!Array.isArray(this.course.assistantIds)) {
            this.course.assistantIds = []
          }
          this.accounts = [
            ...new Set(
              [
                ...this.course.lecturerIds,
                ...this.course.assistantIds,
                this.course.createUser,
              ].map(v => v.toLowerCase())
            ),
          ]
          // #endregion
          this.permission = true
          if (course.state === COURSE_STATE.FORECAST || course.state === COURSE_STATE.LIVING || course.chatGroupOpenFlag) {
            this.initChatRoom(true)
          }
          this.loading = false
          // 如果课程已经结束，判断是否更新chatOpenFlag信息
          if (course.state === COURSE_STATE.ENDED && course.chatGroupOpenFlag) {
            setTimeout(() => {
              this.course.chatGroupOpenFlag = false
            }, Math.max(0, Date.now() - course.endTime + 10 * 60 * 1000)) // 10分钟结束关闭
          }
          sensorHelp.track(LIVE_DETAIL_VISIT, {
            school_course_id: course.pkid,
          })
        })
        .catch(({ msg, code }) => {
          this.$Message.error(msg)
          if (code === 4001 || code === 4006) {
            if (this.isLogin) {
              this.$router.push({ name: 'Home' })
            } else {
              this.$router.push({ name: 'Login' })
            }
          }
        })
    },
    // 从云信获取用户信息，已登录使用登录账号，未登录使用匿名账号
    getSelfInfo (anonymous) {
      // if (this.isLogin) {
      return this.$store
        .dispatch('chat/getSelfInfo')
        .then(this.initNim)
        .catch(() => {
          console.log('<<<< 从云信获取用户信息失败 >>>>')
        })
    },
    // 初始化 NIM 以接收自定义系统通知
    initNim () {
      nimInstance = window.SDK.NIM.getInstance({
        appKey: this.$config.appKey,
        account: this.accid,
        token: this.token,
        onbroadcastmsg: ({ body: content }) => {
          const LIVINGSTATECHANGETYPE = 2
          try {
            const { type, valid, channel, courseId, content: msg } = JSON.parse(content)
            if (courseId === this.course.pkid) {
              // type:2，直播状态变更的类型
              if (type === LIVINGSTATECHANGETYPE) {
                this.course.channel = channel

                if (valid === true) {
                  this.course.state = COURSE_STATE.LIVING
                  this.course.startTime = Date.now()
                  this.$store.dispatch('course/getSignUpDelta', { type: POPUP_TEXT.JOIN_COURSE.value, objectId: this.course.pkid })
                }

                if (valid === false) {
                  this.course.state = COURSE_STATE.ENDED
                  this.$store.dispatch('course/getPowerDelta', { type: POPUP_TEXT.FINISH_COURSE.value, objectId: this.course.pkid })
                  this.showStar = true
                  this.showLearnTime = true
                  clearInterval(this.findCourseStatistisInterval)
                }
              }
              // type:4, 结束后关闭聊天室的类型
              if (type === 4) {
                this.course.chatGroupOpenFlag = false
              }
              // type:5，直播公告更新的类型
              if (type === 5) {
                if (msg.type === 1) {
                  this.$store.commit('chat/updateBroadcast', { courseId, content: msg.content })
                }
                if (msg.type === 2) {
                  this.$store.commit('chat/setMessageTips', { content: msg.content })
                }
              }
              // type:6 课件解锁操作
              if (type === 6) {
                chatBus.$emit('unlockattachment', msg)
              }
            }
          } catch (err) {}
        },
      })
      // chatBus.$emit('initChatroom')
    },
    init () {
      this.loading = true
      this.getCourseDetail()
      this.getBroadcast()
      this.initStatisticVo(this.courseId)
      this.findCourseStatistisInterval = setInterval(() => {
        this.initStatisticVo(this.courseId)
      }, 60000)
      this.from = this.$router.currentRoute.query.from
    },
    initChatRoom (anonymous) { // 初始化聊天室
      this.getSelfInfo(anonymous).then(() => {
        chatBus.$emit('initChatroom')
      })
    },
    getBroadcast () {
      this.$store.dispatch('chat/updateBroadcast', { courseId: this.course.pkid })
    },
    setCourseSingup () { // 设置状态
      if (!this.isLogin) {
        this.$Message.info('请先登录！')
        this.$router.push({ name: 'Login' })
        return
      }
      this.$store
        .dispatch('course/setCourseSingup', {
          courseId: this.course.pkid,
          signUpFlag: !this.course.signUpFlag,
        })
        .then(() => {
          this.course.signUpFlag = !this.course.signUpFlag
          this.$Message.info(this.course.signUpFlag ? '报名成功' : '取消成功')
        })
        .catch(() => {
          this.$Message.info(this.course.signUpFlag ? '取消失败' : '报名失败')
        })
    },
    handleShowPoster () {
      this.$store.commit('course/setShowPoster', true)
    },
    changeCourseProps ({ course, prop, value }) {
      if (this.course.pkid === course.pkid) {
        this.course[prop] = value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/detail.scss';
</style>
